class subscribeBlock extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="email"]');
    this.submitBtn = this.querySelector('button[type="submit"]');
    this.containerMessages = this.querySelector('.message');
    this.closeBtns = this.querySelectorAll('.close-btn');
    this.form = this.querySelector('form');

    this.closeBtns.forEach((btn) =>
      btn.addEventListener('click', () => this.hide()),
    );

    this.input.addEventListener('input', () => {
      if (this.input.checkValidity()) {
        this.submitBtn.disabled = false;
        this.submitBtn.classList.remove('disabled');
      } else {
        this.submitBtn.disabled = true;
        this.submitBtn.classList.add('disabled');
      }
    });

    this.addEventListener('submit', (e) => {
      e.preventDefault();

      this.join();
    });

    this.show();
  }

  disabledContent() {
    this.style.opacity = '0.4';
    this.style.pointerEvents = 'none';
    this.containerMessages.classList.add('hidden');
  }

  enableContent() {
    this.style.opacity = '1';
    this.style.pointerEvents = 'auto';
  }

  show() {
    this.classList.add('visible');
  }

  hide() {
    this.classList.remove('visible');
  }

  join() {
    const form = this.form;
    const formData = new FormData(form);

    this.disabledContent();

    this.containerMessages.innerHTML = '';
    const span = document.createElement('span');

    fetch(`${window.internalApi.baseUrl}/users/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        email: formData.get('email'),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.error) {
          this.containerMessages.classList.add('warning-block');
          span.innerHTML = response.message;
        } else {
          this.containerMessages.classList.add('info-block');
          span.innerHTML = 'Thanks for joining!';
        }

        this.containerMessages.appendChild(span);
      })
      .catch((response) => {
        span.innerHTML = response.message;
        this.containerMessages.appendChild(span);
        this.containerMessages.classList.add('warning-block');
      })
      .finally(() => {
        this.containerMessages.classList.remove('hidden');
        this.enableContent();
        this.form.reset();
      });
  }
}

customElements.define('subscribe-block', subscribeBlock);
